import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Tapahtumat — Frisbeegolfradat' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Yhteisö"
			title="Tapahtumat"
			intro="Tulevat kilpailut, klinikat ja muut frisbeegolftapahtumat."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
